import { FormattedMessage } from 'react-intl';

const Tbm3DidPreconditions = () => (
    <div>
        <div className="text-bold">
            <FormattedMessage id="intl-msg:engineOil.preconditions.dialog.subtitle" />
        </div>
        <ol className="margin-top-25">
            <li className="padding-10">
                <FormattedMessage
                    id="intl-msg:engineOil.preconditions.tbm3Did.static.standingTime"
                    values={{
                        b: (innerText) => <b>{innerText}</b>,
                    }}
                />
            </li>
            <li className="padding-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.tbm3Did.static.engine" />
            </li>
            <li className="padding-10">
                <FormattedMessage
                    id="intl-msg:engineOil.preconditions.tbm3Did.static.ignition"
                    values={{
                        b: (innerText) => <b>{innerText}</b>,
                    }}
                />
            </li>
            <li className="padding-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.tbm3Did.static.flatSurface" />
            </li>
            <li className="padding-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.tbm3Did.static.externalConnectors" />
            </li>
            <li className="padding-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.tbm3Did.static.signal" />
            </li>
        </ol>
    </div>
);

export default Tbm3DidPreconditions;
